<template lang="pug">
  b-container.d-flex.justify-content-center(fluid)
    div#app.m-0(style="max-width: 420px;")
      b-overlay( :show="busy" spinner-variant="primary" spinner-small)
        router-view
      
</template>

<script>
import Section1Widget from './components/Section1Widget.vue'
import ApiHandlingMixin from './common/ApiHandlingMixin.js'
export default {
  name: 'App',
  mixins: [ ApiHandlingMixin ],
  components: {
    Section1Widget,
  },
  data: function(){return {};},
  methods: {
    /** Loads categories onto the _root_ */
    loadCategories: async function(){
      if(!this.categories|| this.categories.length === 0){
        try{
          this.in_process++;
          this.$root.categories = await this.$mobileapi.getAllCategories();
        }catch(ex){
          console.error(ex);
        } finally {
          this.in_process--;
        }
      }
    },
    loadEmployees: async function(){
      if(!this.employees|| this.employees.length === 0){
        try{
          this.in_process++;
          let resp = await this.$mobileapi.getEmployees();
          this.$root.employees = resp.employees;
        }catch(ex){
          console.error(ex);
        } finally {
          this.in_process--;
        }
      }
    },
    loadTranslations: async function(){
      if(!this.translations|| this.translations.length === 0){
        try{
          this.in_process++;
          let resp = await this.$mobileapi.getTranslations();
          this.$root.translations = {};
          resp.translations.forEach(t=>{
            this.$root.translations[t.key]={
              en: t.text_en,
              zh: t.text_zh,
              asset_id: t.asset_id,
            };
          });
        }catch(ex){
          console.error(ex);
        } finally {
          this.in_process--;
        }
      }
    },
    loadAssets: async function(){
      if(!this.assets|| this.assets.length === 0){
        try{
          this.in_process++;
          let resp = await this.$mobileapi.getAssets();
          this.$root.assets = {};
          resp.assets.forEach(a=>{
            this.$root.assets[a.key]={
              asset_id: a.asset_id,
              type: a.asset_type,
              en: a.value_en,
              zh: a.value_zh,
            };
          });
        }catch(ex){
          console.error(ex);
        } finally {
          this.in_process--;
        }
      }
    },
    loadConfiguration: async function(){
      if(!this.$root.configuration ){
        try{
          this.in_process++;
          this.$root.configuration = await this.$mobileapi.getDefaultConfiguration();
        }catch(ex){
          console.error(ex);
        } finally {
          this.in_process--;
        }
      }
    },
  },
  created: async function(){
    try{
      this.in_process++;
      
      await Promise.all([
        this.loadConfiguration(),
        this.loadCategories(),
        this.loadEmployees(),
        this.loadTranslations(),
        this.loadAssets(),
      ]);

    } finally {
      this.in_process--;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
